import type { SiteDocumentsLocale } from "@/locales/fr/site-documents";

import { ESiteDocumentType } from "@/types/backoffice/dto/site-documents/site-document-dto";

const documentTypes: Record<ESiteDocumentType, string> = {
  [ESiteDocumentType.ESC_INVOICE]: "ESC Invoice",
  [ESiteDocumentType.ESC_ESTIMATE_PAPER_PHOTO]: "ESC Estimate Paper Photo",
  [ESiteDocumentType.ELECTRONIC_SEALED_DOCUMENT]: "Electronic sealed photos",
  [ESiteDocumentType.YOUSIGN_AUDIT_TRAIL]: "Yousign audit trail",
  [ESiteDocumentType.ESC_QUOTE]: "ESC Quote",
  [ESiteDocumentType.INSTALLATION_SHEET]: "Installation sheet",
  [ESiteDocumentType.INSTALLATION_SHEET_BASIC]: "Installation sheet basic",
  [ESiteDocumentType.ESC_SWORN_STATEMENT]: "ESC Sworn statement",
  [ESiteDocumentType.TAX_REDUCTION_STATEMENT]: "Tax reduction statement",
  [ESiteDocumentType.ELECTRICITY_BILL]: "Electricity bill",
  [ESiteDocumentType.TRANSFER_SALES]: "Transfer sheet CGU",
  [ESiteDocumentType.TRANSFER_PROVISION]: "Transfer sheet CGM",
  [ESiteDocumentType.INTERVENTION_SALES]: "Maintenance sheet - sales",
  [ESiteDocumentType.INTERVENTION_PROVISION]: "Maintenance sheet - provision",
  [ESiteDocumentType.ESC_CREDIT_NOTE]: "Credit note",
  [ESiteDocumentType.ESTIMATE_ESC_STATEMENT]: "Estimate statement",
  [ESiteDocumentType.ESC_CUSTOMER_SERVICE_CERTIFICATE]: "Customer service certificate",
  [ESiteDocumentType.ELECTRICITY_BILL_PHOTO_PDF]: "Electricity bill photo",
};

const siteDocumentsLocale: SiteDocumentsLocale = {
  siteDocuments: {
    confirm: {
      mail: {
        message: 'You\'re about to send an email to the subscriber with the file "{document}". Do you want to confirm?',
        acceptLabel: "Yes, send it",
        rejectLabel: "Cancel",
      },
    },
    toast: {
      mail: {
        error: {
          notMailable: "This document can't be sent by email.",
          noSite: "No active site found. Please refresh the page.",
          noSubscriber: "This site has no associated subscriber.",
          genericError: "Something went wrong. Please try again later.",
        },
        success: {
          sent: 'The email containing the "{document}" document has been successfully sent to the subscriber. They will receive it in their inbox in a few moment.',
        },
      },
    },
    pageTitle: "Documents",
    table: {
      unknown: "Unknown",
      headers: {
        name: "Name",
        size: "Size",
        date: "Date",
        origin: "Origin",
        actions: "",
        ocrResultStatus: "Document status",
      },
      mail: {
        tooltip: "Send via mail",
      },
    },
    documentTypes,
    empty: {
      title: "No documents",
      description: "No document has been added yet.",
    },
    error: {
      title: "Error",
      description: "An error occurred while loading the documents.",
    },
  },
};

export default siteDocumentsLocale;
